import script from "./GoogleAd.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleAd.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleAd.vue?vue&type=style&index=0&id=72e06f05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e06f05"]])

export default __exports__